import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, switchMap, share, withLatestFrom, map } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { AppState } from '@toro/common/shared/interfaces/app-state.interface';
import { SuitabilityBypassAgreementActions } from './suitability-bypass-agreement.action';
import { HttpHeaders } from '@angular/common/http';
import { UsersState } from '@toro/common/shared/state-management/users/users.reducer';
import { HttpService } from '@toro/common/shared/services/http/http.service';
import { SettingsService } from '@toro/common/shared/services/settings/settings.service';


@Injectable()
export class SuitabilityBypassAgreementEffects {

    constructor(
        private actions$: Actions<SuitabilityBypassAgreementActions>,
        private store: Store<AppState>,
        private httpService: HttpService,
        private settings: SettingsService,
    ) { }

    getSuitabilityBypassAgreement$ = createEffect(() =>
        this.actions$.pipe(
            ofType(SuitabilityBypassAgreementActions.getSuitabilityBypassAgreement),
            withLatestFrom(this.store.select((authStore) => authStore.authentication)),
            switchMap(([action, auth]) => {
                const apiUrl = this.settings.getConfigurationKeyValue('ipoBackendUrl');
                const isLogged = !!(auth.currentUser && auth.currentUser.token);
                return this.httpService.get(`${apiUrl}/user-acceptance/unsuitable-profile-user-awareness`, this._createHeaders(auth, isLogged))
                    .pipe(
                        map((suitabilityBypassAgreement: any) => {
                            if (suitabilityBypassAgreement) {
                                return {
                                    type: SuitabilityBypassAgreementActions.getSuitabilityBypassAgreementSuccess,
                                    payload: suitabilityBypassAgreement
                                };
                            }

                            return { type: SuitabilityBypassAgreementActions.getSuitabilityBypassAgreementError, payload: 'No suitability bypass agreement data received.' };
                        }),
                        catchError((error) => of({ type: SuitabilityBypassAgreementActions.getSuitabilityBypassAgreementError, payload: error }))
                    );
            }),
            share())
    );


    updateSuitabilityBypassAgreement$ = createEffect(() =>
        this.actions$.pipe(
            ofType(SuitabilityBypassAgreementActions.updateSuitabilityBypassAgreement),
            withLatestFrom(this.store.select((authStore) => authStore.authentication)),
            switchMap(([action, auth]) => {
                const apiUrl = this.settings.getConfigurationKeyValue('ipoBackendUrl');
                const isLogged = !!(auth.currentUser && auth.currentUser.token);
                return this.httpService.put(`${apiUrl}/user-acceptance/unsuitable-profile-user-awareness`, action.payload.data, this._createHeaders(auth, isLogged))
                    .pipe(
                        map((suitabilityBypassAgreement: any) => {
                            if (suitabilityBypassAgreement) {
                                return {
                                    type: SuitabilityBypassAgreementActions.updateSuitabilityBypassAgreementSuccess,
                                    payload: suitabilityBypassAgreement
                                };
                            }
                            
                            return { type: SuitabilityBypassAgreementActions.updateSuitabilityBypassAgreementError, payload: 'No suitability bypass agreement update data received.' };
                        }),
                        catchError((error) => of({ type: SuitabilityBypassAgreementActions.updateSuitabilityBypassAgreementError, payload: error }))
                    );
            }),
            share())
    );


    private _createHeaders(userData: UsersState, logged: boolean = false) {
        if (!logged) {
            return new HttpHeaders({
                'Content-Type': 'application/json; charset=UTF-8',
                'X-SessionID': `${userData.sessionID}`,
            });
        } else {
            return new HttpHeaders({
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': `Bearer ${userData.currentUser.token}`,
            });
        }
    }
}